import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ITab } from '../../_entities';

@Component({
    selector: 'tab-strip',
    template: require('./tab-strip.template.html')
})
export class TabStripComponent implements OnInit {
    @Input() tabs: ITab[];
    @Input() activeTab: ITab;
    @Output() tabStripChanged = new EventEmitter<ITab>();
    nullValue: null;

    constructor() {
    }

    ngOnInit() {
    }


    setActiveTab(tab: ITab) {
        this.activeTab = tab;
        this.tabStripChanged.emit(tab);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/tab-strip.component.ts